import "../../Assets/Styles/Footer.css";
import {Link} from "react-router-dom";
import {HashLink} from "react-router-hash-link";
import {useTranslation} from "react-i18next";

export default function Footer() {
    const {i18n} = useTranslation();

    return (
        <footer className="footer">
            <div className="footer-sect">
                <div className="footer-sect-item">
                    <div className="footer-logo">
                        <img className="footer-logo-img" alt="logo"
                             src="https://res.cloudinary.com/dvjdkgzbe/image/upload/v1679065562/FunRecycle/Logo-min_fcl7gr.svg"
                        />
                        <p>FUN recycle</p>
                    </div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                </div>
                <span>FUN recycle © 2022</span>
            </div>
            <div className="footer-sect">
                <div className="footer-heading">{i18n.t("Links")}</div>
                <HashLink smooth to="/">{i18n.t("Home")}</HashLink>
                <HashLink smooth to="/#about">{i18n.t("About")}</HashLink>
                <HashLink smooth to="/#features">{i18n.t("Features")}</HashLink>
                <HashLink smooth to="/#reviews">{i18n.t("Reviews")}</HashLink>
                <HashLink smooth to="/#download">{i18n.t("Download")}</HashLink>
            </div>
            <div className="footer-sect">
                <div className="footer-heading">{i18n.t("Contacts")}</div>
                <div>+38(063)444-88-77</div>
                <div>fun.recycle@gmail.com</div>
                <div className="footer-links">
                    <Link to="#" aria-label="facebook">
                        <img alt="logo"
                             src="https://res.cloudinary.com/dvjdkgzbe/image/upload/v1679065565/FunRecycle/facebook-logo-min_v9mmbj.svg"
                        />
                    </Link>
                    <Link to="#" aria-label="instagram">
                        <img alt="logo"
                             src="https://res.cloudinary.com/dvjdkgzbe/image/upload/v1679065562/FunRecycle/instagram-logo-min_vgbojo.svg"
                        />
                    </Link>
                    <Link to="#" aria-label="twitter">
                        <img alt="logo"
                             src="https://res.cloudinary.com/dvjdkgzbe/image/upload/v1679065565/FunRecycle/twitter-logo-min_wcgoew.svg"
                        />
                    </Link>
                </div>
            </div>
        </footer>
    );
}